<script>
export default {
  props: {
    underline: { type: Boolean, default: true }
  },
  watch: {
    defaultIdx: {
      immediate: true,
      handler(newVal) {
        this.currIdx = newVal;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.lego-tab__label--mini {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;

  &.lego-tab__label {
    min-width: inherit;
    background-color: $color--ui-white;
    position: relative;
    overflow: inherit;
    height: 32px;
    margin-right: 2px;
  }
}

.lego-tab__label--active {
  &:after {
    content: '';
    position: absolute;
    height: 1px;
    width: 100%;
    left: 0;
    bottom: -1px;
    display: inline-block;
    background-color: $color--ui-white;
  }
}

:deep .lego-tab__label-underline {
  &.lego-tab__label--mini {
    padding: 0 15px;
  }
  &[disabled] {
    pointer-events: none;
    color: $color--ui07;
  }

  &--active {
    .lego-tab__label--mini {
      @include font(14px, 500, 32px);
      position: relative;
      top: 1px;
    }

    @include font(16px, 700, 39px);

    &:after {
      height: 2px;
      border-bottom: 2px solid $color--primary;
    }
  }

  &:hover {
    background-color: transparent;
    color: $color--primary;
  }
}

.lego-tab__content {
  padding-top: 24px;
}
</style>
